import {dashboardChartColors} from '../../../../../../util/uiconstants';
import {labels as utilLabels} from '../../../../../../util/utils';

import {config as barchartColumnConfig} from '../../common/BarchartColumn';

const prop = 'reviewerStatusColumn';
export const id = 'reviewerAssignmentsStatus';

export const config = (labels) =>
	barchartColumnConfig({
		fullId: id,
		label: labels.status,
		prop,
		customHeaderTooltip: utilLabels.basedOnReviewerAssignments,
		getSeries: (item) => [
			{
				name: utilLabels.closed,
				data: [item.rACompld],
				color: dashboardChartColors.blue[3]
			},
			{
				name: utilLabels.inprogress,
				data: [item.rAInProg],
				color: dashboardChartColors.blue[2]
			},
			{
				name: utilLabels.open,
				data: [item.rANotStart],
				color: dashboardChartColors.blue[0]
			}
		]
	});
